import React from 'react'
import { classNames } from '../../../utils/classNames'

const TemplateInvitation = ({
	headerTitle,
	title,
	titlePrefix,
	description,
	maxSteps,
	currentStep,
	onNextClickEvent,
	onPreviousClickEvent,
	onSkip,
	children
}: {
	headerTitle: string,
	titlePrefix: string,
	title: string,
	description: string,
	maxSteps: number,
	currentStep: number,
	onSkip?: () => void,
	onNextClickEvent: () => void,
	onPreviousClickEvent?: () => void,
	children: React.ReactElement
}) => (
	<div className='font-inter w-full md:w-[490px] lg:w-[760px] mx-auto mt-5 md:mt-12 dark:text-white'>
		<div className='flex flex-wrap'>
			<div className='w-full md:w-9/12'>
				<h4 className='text-sm text-opacityTitle dark:text-white mb-1'>
					{headerTitle}
				</h4>
				<div className='flex flex-wrap'>
					<div className='flex flex-row py-2'>
						{Array(maxSteps).fill(0).map((_e, index: number) => (
							<div key={index} className={classNames('w-7 h-2.5 rounded-3xl mr-1', currentStep >= index + 1 ? 'bg-primary-default dark:bg-white' : 'bg-inactive dark:bg-slate-500')} />
						))}
					</div>
					<div>
						{onSkip && <button onClick={onSkip} className='ml-5 text-primary-default dark:text-white font-normal text-sm md:text-lg underline' type='button'>
							Skip
						</button>}
					</div>
				</div>
				<h2 className='text-2xl md:text-4xl font-medium mb-3'>
					<span className='font-bold mr-2'>{titlePrefix}</span>
					{title}
				</h2>
				<p className='font-normal text-sm md:text-lg'>{description}</p>
			</div>
			<div className='ml-auto mt-5 md:mt-14'>
				{onPreviousClickEvent && <button onClick={onPreviousClickEvent} className=' bg-primary-default dark:text-white rounded-xl px-3 py-1 text-base text-white h-12 hover:bg-opacity-90 mr-2' type='button'>
					Previous
				</button>}
				<button onClick={onNextClickEvent} className='bg-primary-default dark:text-white rounded-xl px-3 py-1 text-base text-white h-12 hover:bg-opacity-90' type='button'>
					Next
				</button>
			</div>
		</div>
		<div className='my-5'>
			{children}
		</div>
	</div>
)

export default TemplateInvitation;